<template>
  <div id="body">
    <main-navigation></main-navigation>

    <base-card>
      <h5 class="mb-3">Approved College Students</h5>

      <!-- SEARCH INPUT -->
      <input
        type="text"
        class="form-control mb-3"
        placeholder="Search by student name, school, admin number, or voter name..."
        v-model="searchTerm"
      />

      <!-- RESULTS TABLE -->
      <table class="table table-striped table-bordered table-sm">
        <thead>
          <tr>
            <th>No.</th>
            <th>Student Name</th>
            <th>Admin No</th>
            <th>School</th>
            <th>Ward</th>
            <th>Amount</th>
            <th>user Remarks</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(student, index) in filteredStudents"
            :key="student.id"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ student.studentName }}</td>
            <td>{{ student.adminNumber }}</td>
            <td>{{ student.schoolName }}</td>
            <td>{{ student.ward }}</td>
            <td>{{ student.amount_awarded }}</td>
            <td>{{ student.user_remarks }}</td>
          </tr>

          <tr v-if="filteredStudents.length === 0">
            <td colspan="7" class="text-center text-muted">
              No matching records found
            </td>
          </tr>
        </tbody>
      </table>

      <small class="text-muted">
        Showing {{ filteredStudents.length }} of {{ students.length }} records
      </small>
    </base-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      students: [],
      searchTerm: ""
    };
  },

  computed: {
    filteredStudents() {
      if (!this.searchTerm) {
        return this.students;
      }

      const term = this.searchTerm.toLowerCase();

      return this.students.filter(s =>
        (
          s.studentName +
          " " +
          s.schoolName +
          " " +
          s.adminNumber +
          " " +
          s.voter_full_name
        )
          .toLowerCase()
          .includes(term)
      );
    }
  },

  created() {
    axios
      .get("https://api.roberms.com/nyamoko/get/college/approved")
      .then(res => {
        this.students = res.data;
      })
      .catch(err => {
        console.error("Error loading students", err);
      });
  }
};
</script>

<style scoped>
table {
  font-size: 13px;
}
input {
  font-size: 14px;
}
</style>
